import React from "react";
import { IconT } from "types/utils";

export const BatteryTileIcon = ({ width = 34, height = 35, fill = "none", ...rest }: IconT) => {
  return (
    <svg width={width} height={height} viewBox="0 0 34 35" fill={fill} xmlns="http://www.w3.org/2000/svg" {...rest}>
      <rect y="0.5" width="34" height="34" rx="17" fill="#0070F4" fillOpacity="0.11" />
      <rect
        x="10.75"
        y="13.25"
        width="10.5"
        height="8"
        rx="2"
        stroke="url(#paint0_linear_battery_tile)"
        strokeWidth="1.3"
      />
      <rect x="22" y="15.75" width="1.5" height="3" rx="0.75" fill="url(#paint0_linear_battery_tile)" />
      <rect x="12.5" y="15.25" width="2" height="4" rx="0.6" fill="url(#paint0_linear_battery_tile)" />
      <rect x="15.5" y="15.25" width="2" height="4" rx="0.6" fill="url(#paint0_linear_battery_tile)" />
      <defs>
        <linearGradient
          id="paint0_linear_battery_tile"
          x1="10.75"
          y1="13.25"
          x2="23.5"
          y2="13.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#07469A" />
          <stop offset="1" stopColor="#0070F4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BatteryTileIcon;
